import { Component, EventEmitter } from '@angular/core';
import { UserManagementService } from 'app/services/user-management.service';
import { DataService } from "../../services/data.service";
import { FrontEndService } from "../../services/front-end.service";
import { Location } from '@angular/common';
import { StateService} from '@uirouter/angular';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent {
    name_error = false;
    title_error = false;
    username_error = false;
    role_error = false;
    role: number;
    role_name: string;
    username = "";
    name = "";
    title = "";
    mobile_number = "";
    errorMessage = "";
    path = "app/users/register/";
    closeResult: string;
    fullScreenLoader = false;

    // Focus Variables
    public name_focus =  new EventEmitter<boolean>();

    constructor(
        private user_management_service: UserManagementService,
        public dataService: DataService,
        private stateService: StateService,
        public front_end_service: FrontEndService,
        private _location: Location,
    ) { }

    onSubmit(user) {
        if (user["name"].trim() === "" || user["name"] === undefined) {
            this.name = "";
            this.name_focus.emit(true);
            this.name_error = true;
            this.errorMessage = 'enter_your_name.'
        } else {
            user["title"] = this.title;
            if(user['title'] === null) {
                user['title'] = '';
                this.title = "";
            }
            this.role_error = false;
            this.title_error = false;
            this.username_error = false;
            this.name_error = false;
            this.fullScreenLoader = true;
            this.user_management_service.updateProfile(user, this.dataService.currentUser['id'], (resp) => {
                this.fullScreenLoader = false;

                if(resp.status) {
                    const data = resp.data;
                    this.role = data.role;
                    this.role_name = data.role_name;
                    this.username = data.username;
                    this.name = data.name;
                    this.title = data.title;
                    this.mobile_number = data.mobile_number;

                    this.front_end_service.addToast(
                        "Success",
                        "user_profile_updated",
                        "success"
                    );

                    this.front_end_service.back();
                }
            });
        }
    }
}
